import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";

function ProjectCard() {
  const AnimatedNumber = ({ children }) => {
    const regex = /(\d+)([^\d]+)/;
    const matches = children.match(regex);
    const target = matches ? parseInt(matches[1], 10) : parseInt(children, 10);
    const suffix = matches ? matches[2] : "";
    const [count, setCount] = useState(0);

    // Intersection Observer Hook
    const { ref, inView } = useInView({
      triggerOnce: true, // Trigger animation only once
      threshold: 0.5, // Trigger when 50% of the element is in view
    });

    useEffect(() => {
      let timer;
      if (inView && count < target) {
        const inc = target / 100;
        timer = setTimeout(() => setCount(count + inc), 20);
      }
      return () => clearTimeout(timer);
    }, [inView, count, target]);

    return (
      <div ref={ref}>
        <h1>{`${Math.min(count, target).toFixed(0)}${suffix}`}</h1>
      </div>
    );
  };
  return (
    <Container>
      <Slot background="linear-gradient(180deg, #0000004A 0%, var(--primary-color) 100%), url('./Card/i1.jpg')">
        <AnimatedNumber>55+</AnimatedNumber>
        <p>Trusted Clients</p>
      </Slot>

      <Slot background="linear-gradient(180deg, #0000004A 0%, var(--primary-color) 100%), url('./Card/i2.jpg')">
        <AnimatedNumber>167</AnimatedNumber>
        <p>Fascinating Videos</p>
      </Slot>

      <Slot background="linear-gradient(180deg, #0000004A 0%, var(--primary-color) 100%), url('./Card/i3.jpg')">
        <AnimatedNumber>7</AnimatedNumber>
        <p>Years in the Industry</p>
      </Slot>

      <Slot background="linear-gradient(180deg, #0000004A 0%, var(--primary-color) 100%), url('./Card/i4.jpg')">
        <AnimatedNumber>25+</AnimatedNumber>
        <p>Film Crew On Board</p>
      </Slot>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  height: 350px;
  //padding: 0 10px;
  flex-wrap: wrap;
  //border: 2px solid red;
  border-radius: 25px;
  background: black;

  @media only screen and (max-width: 1200px) {
    height: 450px;
  }
`;
const Slot = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  //border-radius: 25px;
  background: ${(props) => props.background};
  background-size: cover;
  transition: background-size 0.1s ease, background-position 0.9s ease;
  @media only screen and (max-width: 1200px) {
    width: 50%;
    height: 50%;
  }

  &:hover {
   // background-position: calc(50% - 10px);
    filter: brightness(1.1);
    cursor: pointer;
  }

  h1 {
    font-size: 120px;
    color: #fff;

    @media only screen and (max-width: 1200px) {
      font-size: 74px;
    }
  }
  p {
    font-size: 19px;
    color: #fff;
    text-transform: capitalize;

    @media only screen and (max-width: 1200px) {
      font-size: 15px;
    }
  }
`;
export default ProjectCard;
